import React from 'react';
import { ArraySlot } from 'react-plugin';
export function NavPanelRowSlot({ slotProps, plugOrder }) {
    return (React.createElement(ArraySlot, { name: "navPanelRow", slotProps: slotProps, plugOrder: plugOrder }));
}
